export default __webpack_public_path__ + "static/media/step-3-activate.14381353.svg";